import { Box, Chip } from "@mui/material"
import { KeyboardArrowRightOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import React from "react"

import { handleFileAction } from "../../utils"

import type { SignedUrl } from "@/graphql/codegen/graphql"

interface FileChipProps {
  file: SignedUrl
  showExtension?: boolean
  showFileName?: boolean
}

const FileChip: FC<FileChipProps> = ({ file, showExtension = true, showFileName = true }) => {
  const fileName = file?.file?.originalName as string
  const extension = fileName.split(".").pop()?.toLowerCase()

  const onFileClick = () => {
    void handleFileAction(file)
  }
  return (
    <Chip
      avatar={
        extension && showExtension ? (
          <Box className='flex w-fit items-center justify-center rounded bg-gray-500 p-1'>
            {extension.toUpperCase()}
          </Box>
        ) : undefined
      }
      label={showFileName && <span className='px-1'>{fileName}</span>}
      variant='filled'
      size='small'
      className='rounded bg-gray-300 text-gray-900 hover:bg-primary-300'
      onClick={onFileClick}
      deleteIcon={<KeyboardArrowRightOutlined className='text-gray-800' />}
      onDelete={onFileClick}
      clickable
    />
  )
}

export default FileChip
